module.exports = new __parcel__URL__("bear.6250dade.svg").toString();